import { Card, CardBody, Col } from "reactstrap";
import { IconsWithPrefixAndPostfixTitle } from "../../../../../../Constants/Constants";
import CommonPrefixAndPostfix from "../Common/CommonPrefixAndPostfix";
import CommonCardHeader from "../../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { TouchspinSubTitle } from "../../../../../../Data/Forms&Table/Forms/FormWidgets";

const IconsWithPrefixAndPostfix = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={IconsWithPrefixAndPostfixTitle} span={TouchspinSubTitle} />
        <CardBody className="common-flex pre-post-touchspin">
          <CommonPrefixAndPostfix preIcon />
          <CommonPrefixAndPostfix postIcon />
        </CardBody>
      </Card>
    </Col>
  );
};
export default IconsWithPrefixAndPostfix;
